export enum CardType {
  DEFAULT,
  HORIZONTAL_BLUE,
  VERTICAL_BLUE,
  VERTICAL_SUCCESS,
  VERTICAL_WARNING,
  VERTICAL_ERROR,
  VERTICAL_GREY,
}
